import versifyUrl from '@/assets/images/case-1.webp?url'
import rosypetUrl from '@/assets/images/case-2.webp?url'

export interface CaseEntry {
  key: string
  imgUrl: string
}

// Display order for the case studies. The `key` is used both as the i18n
// namespace (`cases.projects.<key>.*`) and as the route slug.
export const cases: CaseEntry[] = [
  { key: 'versify', imgUrl: versifyUrl },
  { key: 'rosypet', imgUrl: rosypetUrl },
]

export function caseByKey(key: string): CaseEntry {
  return cases.find((c) => c.key === key) ?? cases[0]
}
